export default class GenerateCoverLetterEntity {
  constructor({ title, body, reasons, closing }) {
    this.title = title;
    this.body = body;
    this.reasons = Array.isArray(reasons) ? reasons : [];
    this.closing = closing;
  }

  static fromJson(json) {
    if (!json) {
      console.error("❌ Empty AI JSON:", json);
      throw new Error("AI response is empty");
    }

    // AI возвращает поля напрямую (title/body/reasons/closing)
    const title = json.title?.trim();
    const body = json.body?.trim();
    const closing = json.closing?.trim();

    if (!title || !body || !closing) {
      console.error("❌ AI message content is incomplete:", json);
      throw new Error("AI response missing content");
    }

    return new GenerateCoverLetterEntity({
      title,
      body,
      reasons: json.reasons || [],
      closing
    });
  }
}